import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
}

// ─────────────────────────────────────────────────────────────────
// CAUSA RAÍZ DE LOS PROBLEMAS EN MÓVIL:
// Sin timeout en fetch, las peticiones de red en móvil (redes
// celulares, señal débil) pueden colgarse INDEFINIDAMENTE.
// El navegador de escritorio tiene rutas más estables y no falla,
// pero el celular con señal variable sí se queda colgado.
//
// Adicionalmente, el WebSocket de Realtime de Supabase falla en
// redes celulares y puede bloquear todo el cliente de Supabase.
// ─────────────────────────────────────────────────────────────────
const fetchConTimeout = (url, options = {}) => {
  const controller = new AbortController();
  // 15 segundos máximo por petición — después falla limpiamente
  const id = setTimeout(() => controller.abort(), 15000);
  return fetch(url, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(id));
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Mantiene la sesión en localStorage para no re-autenticar en cada carga
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
  global: {
    // Reemplaza el fetch nativo por uno con timeout de 15s
    fetch: fetchConTimeout,
  },
  realtime: {
    // Desactivar WebSocket de Realtime: en redes celulares el WebSocket
    // puede fallar y hacer que todo el cliente de Supabase quede bloqueado
    params: { eventsPerSecond: 0 },
  },
});
